import React from 'react';
import List from '@material-ui/core/List';

import { ThemeConfig } from '../themes';
import { useBrandingData, useFeatureEnables } from '../dataProviders';
import NavLogo from '../components/NavLogo';
import NavDrawerItem from '../components/NavDrawerItem';

import { makeLogoStyles, makeNavDrawerStyles } from './NavBar';


const useLogoStyles = makeLogoStyles( theme  => ({
  // layout specific styles here
  root: {
    textAlign: 'center',
    margin: '50px',
    width: '100%',
  }
}));

const useNavDrawerStyles = makeNavDrawerStyles( (theme: ThemeConfig) => ({
  // layout specific styles here
  item: {
    fontWeight: 'bold !important',
  },
  list: {
    fontWeight: 'bold !important',
  }
}));

const LinkList = ({ classes={} }:{
  classes?: {
    list?: string,
    item?: string
  }
}) => {
  const { showMenuLinks } = useFeatureEnables();
  const { menu_links = [] } = useBrandingData();
  const validItems = menu_links.filter( item => (item && item.url && item.text) );
  if( !showMenuLinks ) {
    return null;
  }
  return (
    <List className={classes.list}>
      { validItems.map( item => (
        <NavDrawerItem key={item.text} text={item.text} href={item.url} className={classes.item} />
      ))}
    </List>
  );
}


export default function VerticalAppBar() {
  const logoClasses = useLogoStyles();
  const navDrawerClasses = useNavDrawerStyles();

  const WrappedLinkList = (props: any = {}) => <LinkList classes={navDrawerClasses} {...props} />;

  return <>
    <NavLogo classes={logoClasses} />
    <WrappedLinkList />
  </>;
}

VerticalAppBar.propTypes = {
};